import { render, staticRenderFns } from "./TemplateIndex.vue?vue&type=template&id=49b36051&scoped=true"
import script from "./TemplateIndex.vue?vue&type=script&lang=js"
export * from "./TemplateIndex.vue?vue&type=script&lang=js"
import style0 from "./TemplateIndex.vue?vue&type=style&index=0&id=49b36051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b36051",
  null
  
)

export default component.exports